/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  manufacturerIdLabel,
  nameLabel,
  rebateProgramLabel,
  quarterRangeLabel,
  invoiceStatusLabel,
  URAUsedLabel,
  invoiceNumberLabel,
  invoiceDateLabel,
  balanceDueLabel,
  overriddenLabel,
  paidInFullLabel,
  accountReceivableNDCDatailLabel,
  estimatePrincipalDue,
  numUnitsLabel,
  interestDueLabel,
  principalDueError,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { accountReceivableNDCDetailColumns } from '../tablehead';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  setNDCActivityHeader,
  getAcctRecvbyQtrNDCActivity,
  setNDCActivityResponse,
  ndcActivityFirstLoadAction,
} from '../AccRecNDCActivity/store/actions';
import {
  goToNDCActivity,
  declareNDCBalanced,
  undoDeclareNDCBalanced,
  getInvoiceDetails,
  getDrugQtrDetails,
  undoInvoiceBalanced,
  modifyUnitsFromAcctRecv,
  overrideInterestFromAR,
  getExistingCorrLinkIds,
} from '../ARCommonFunctions';
import * as AR_CONST from '../AccountsRevConstants';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  singleAccRecNDCDetail,
  dispatchNDCBalanceDue,
  dispatchNDCOveridden,
  dispatchNDCPaidInFull,
  dispatchModificationFromAr,
  setUnitsToClaimOnload,
  ndcDetailFirstLoadAction,
  getRefreshTableData,
} from './store/actions';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import { exportPDF } from './ExportPDF';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import moment from 'moment';

const AccRecNDCDetail = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [NDCDetailTBData, setNDCDetailTableData] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [dialogText, setDialogText] = React.useState('');
  const [numOfUnitsValue, setNumOfUnitsValue] = React.useState('');
  const [calculatePriDue, setCalculatePriDue] = React.useState(null);
  const [drugQtrDetail, setDrugQtrDetail] = React.useState([]);
  const [showEstPriDue, setEstPriDue] = React.useState(false);
  const [confimPopup, setConfimPopup] = React.useState(false);
  const [confirmPopupData, setConfirmPopupData] = React.useState({
    callFrom: '',
    popupText: '',
  });
  const [undoData, setUndoData] = React.useState({});
  const [modifyUnitsPopup, setModifyUnitsPopup] = React.useState(false);
  const [modifyUnitsRowData, setModifyUnitsRowData] = React.useState({});
  const [overridePopupData, setOverridePopupData] = React.useState({});
  const [interestDue, setInterestDue] = React.useState('');
  const [setUnitsPopupData, setSetUnitsPopupData] = React.useState({});
  const [noClaimPopup, setNoClaimPopup] = React.useState({});
  const [flag, setFlag] = useState(false);
  const [pinned, setPinned] = React.useState();
  const activepgmCode = props?.location?.state?.rebateProgram
    ? props?.location?.state?.rebateProgram
    : props?.location?.value?.state?.rebateProgram;
  const find_NDCDetail = useSelector((state) =>
    state?.sharedState?.AccRecNDCDetailReducer?.getSingleAccRecNDCDetailList?.find(
      (obj) => {
        return obj[activepgmCode];
      }
    )
  );
  const NDCDetail = find_NDCDetail?.[activepgmCode];
  const find_singleNdcDetailList = useSelector((state) =>
    state?.sharedState?.AccRecNDCDetailReducer?.singleNdcDetailList?.find(
      (obj) => {
        return obj[activepgmCode];
      }
    )
  );
  const singleNdcDetailList = find_singleNdcDetailList?.[activepgmCode];
  const ndc_activity_response = useSelector(
    (state) =>
      state?.sharedState?.AccRecNDCActivityReducer?.ndc_activity_response
  );
  const find_getBalnceDue = useSelector((state) =>
    state?.sharedState?.AccRecNDCDetailReducer?.getBalnceDue?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getBalnceDue = find_getBalnceDue?.[activepgmCode]
    ? find_getBalnceDue?.[activepgmCode]
    : false;
  const find_getOverridden = useSelector((state) =>
    state?.sharedState?.AccRecNDCDetailReducer?.getOverridden?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getOverridden = find_getOverridden?.[activepgmCode]
    ? find_getOverridden?.[activepgmCode]
    : false;
  const find_getPaidInFull = useSelector((state) =>
    state?.sharedState?.AccRecNDCDetailReducer?.getPaidInFull?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const getPaidInFull = find_getPaidInFull?.[activepgmCode]
    ? find_getPaidInFull?.[activepgmCode]
    : false;
  const modificationFromAr = useSelector(
    (state) => state?.sharedState?.AccRecNDCDetailReducer?.modificationFromAr
  );
  const ndcDetailFirstLoad = useSelector(
    (state) => state?.sharedState?.AccRecNDCDetailReducer?.ndcDetailFirstLoad
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const commentsData = (status, id) => {
    setShowComments(status);
    setCorrLinkId(id);
  };

  React.useEffect(() => {
    if (ndc_activity_response && ndc_activity_response.status === '001') {
      goToNDCActivity(props.history, dispatch);
      dispatch(ndcActivityFirstLoadAction(false));
      dispatch(setNDCActivityResponse(null));
    }
  }, ndc_activity_response);
  const getBgHighlighterColor = (obj) => {
    let bgColor = '';
    if (
      obj.status === 'DB' ||
      obj.status === 'FG' ||
      obj.status === 'WO' ||
      obj.status === 'DBK' ||
      obj.unitsModFromArInd === 1
    ) {
      bgColor = 'green-legend';
    } else if (obj.actions === 'hide') {
      bgColor = 'd-none';
    }
    return bgColor;
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          originalInvoiceAmount: sum('originalInvoiceAmount'),
          currentInvoiceAmount: sum('currentInvoiceAmount'),
          currentRebateOffsetAmount: sum('currentRebateOffsetAmount'),
          baseStateRebateAmount: sum('baseStateRebateAmount'),
          principalPaid: sum('principalPaid'),
          offsetPaidAmount: sum('offsetPaidAmount'),
          baseStatePaidAmount: sum('baseStatePaidAmount'),
          principalDue: sum('principalDue'),
          offsetDue: sum('offsetDue'),
          baseStateAmountDue: sum('baseStateAmountDue'),
          interestCalculated: sum('interestCalculated'),
          interestPaid: sum('interestPaid'),
          interestDue: sum('interestDue'),
          totalAmountDue: sum('totalAmountDue'),
          disputedAmount: sum('disputedAmount'),
          originalReimburseAmountOnClaims: sum(
            'originalReimburseAmountOnClaims'
          ),
          originalOtherpaymentsfromClaims: sum(
            'originalOtherpaymentsfromClaims'
          ),
          currentReimburseAmountOnClaims: sum('currentReimburseAmountOnClaims'),
          federalAmount: sum('federalAmount'),
          stateAmount: sum('stateAmount'),
          currentOtherPaymentsfromClaims: sum('currentOtherPaymentsfromClaims'),
          status: 'Total:',
          actions: 'hide',
          originalUnits: '',
          currentUnits: '',
          unitsPaid: '',
          unitsUnpaid: '',
          unitsDisputed: '',
          originalURA: '',
          currentURA: '',
          familyPlanningindicator: null,
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    } else {
      const data = [
        {
          originalInvoiceAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaloriginalInvoiceAmount,
          currentInvoiceAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalcurrentInvoiceAmount,
          currentRebateOffsetAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalcurrentRoa,
          baseStateRebateAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalbaseStateRebateAmount,
          principalPaid:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalprincipalPaid,
          offsetPaidAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaloffsetPaidAmount,
          baseStatePaidAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalbaseStatePaidAmount,
          principalDue:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalprincipalDue,
          offsetDue:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaloffsetDue,
          baseStateAmountDue:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalbaseStateAmountDue,
          interestCalculated:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalinterestCalculated,
          interestPaid:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalinterestPaid,
          interestDue:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalinterestDue,
          totalAmountDue:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaltotalAmountDue,
          disputedAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaldisputedAmount,
          originalReimburseAmountOnClaims:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaloriginalReimburseAmountOnClaims,
          originalOtherpaymentsfromClaims:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finaloriginalOtherpaymentsfromClaims,
          currentReimburseAmountOnClaims:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalcurrentReimburseAmountOnClaims,
          currentOtherPaymentsfromClaims:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalcurrentOtherPaymentsfromClaims,

          federalAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalfederalAmount,
          stateAmount:
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
              ?.finalstateAmount,
          status: 'Total:',
          actions: 'hide',
          originalUnits: '',
          currentUnits: '',
          unitsPaid: '',
          unitsUnpaid: '',
          unitsDisputed: '',
          originalURA: '',
          currentURA: '',
          familyPlanningindicator: null,
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    }
  }, [filterApply, filteredRows]);

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const handleShowDrugActivity = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        invoiceScript: row?.originalInvoiceScripts,
        reimburseAmt: row?.originalReimburseAmountOnClaims,
        drugSeqNum: row?.drugSeqNum,
        startQtr:
          singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebatePrgogramCd: singleNdcDetailList?.pgmCd,
      };
      dispatch(getAcctRecvbyQtrNDCActivity(payload));

      const NDCActivityHeaderData = {
        mfgId: singleNdcDetailList.mfgId,
        mfgName: singleNdcDetailList.mfgName,
        quarter: singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebateProgram: singleNdcDetailList?.pgmInfo,
        URAUsed: singleNdcDetailList?.uraInfo,
        ndc: row.ndc,
        drugName: row.drugName,
        ndcStatus: row.status,
        drugSeqNum: row.drugSeqNum,
      };
      dispatch(setNDCActivityHeader(NDCActivityHeaderData));
    }
  };

  const handleDeclareNDCBalanced = (row) => {
    if (row) {
      setLoad(true);
      getInvoiceDetails(singleNdcDetailList.invoiceNum).then((invDtl) => {
        if (invDtl) {
          if (!invDtl?.invoiceFreezeDt) {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.NDCBalancedFrozen);
          } else if (
            singleNdcDetailList.invoiceStatus === 'DB' ||
            singleNdcDetailList.invoiceStatusCd === 'DB'
          ) {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.NDCAlreadyBalanced);
          } else if (row.data?.status === 'DB') {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.NDCAlreadyBalanced);
          } else {
            // API call fn : declareNDCBalanced
            const payload = {
              drugSeqNum: row.data.drugSeqNum,
              startQtr:
                singleNdcDetailList?.getQuarterValue ||
                singleNdcDetailList?.qtr,
              rebatePrgogramCd: singleNdcDetailList?.pgmCd,
              contractSequenceNum: row.data.contractSeqNum,
              invoiceNum: singleNdcDetailList?.invoiceNum,
              numOfUnits: parseFloat(row.data.originalUnits),
              currURA: row.data.currentURA,
              amountPaid: row.data.principalPaid,
              interestDue: row.data.interestDue,
              statusCd: row.data.status,
              isDeclareInvoice: 'N',
              labelerCd: row.data.productCd,
              // asTypeCd: 'DB',
            };
            declareNDCBalanced(payload).then((res) => {
              if (res && res.data.status === '001') {
                setIsDialogOpen(true);
                if (res.data.response.ndcStatus === 'DB') {
                  setDialogText(AR_CONST.NDCBalancedCompleted);
                  const updatedStatusData =
                    NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO.map(
                      (item) => {
                        if (item.drugSeqNum === row.data.drugSeqNum)
                          item.status = 'DB';
                        return item;
                      }
                    );
                  const updateData = {
                    ...NDCDetail,
                    acctRecvMfgNDCDetaillSingleServiceResonse: {
                      ...NDCDetail.acctRecvMfgNDCDetaillSingleServiceResonse,
                      acctRecvMfgNDCDetailSingleRpcResponseVO:
                        updatedStatusData,
                    },
                  };
                  setNDCDetailTableData(
                    JSON.parse(JSON.stringify(updatedStatusData))
                  );
                  dispatch(
                    singleAccRecNDCDetail(
                      JSON.parse(
                        JSON.stringify({ [activepgmCode]: updateData })
                      )
                    )
                  );
                  if (gridApi) gridApi.api.refreshCells();
                } else {
                  setDialogText(res.data.response.responseMessage);
                }
              } else {
                setIsDialogOpen(true);
                setDialogText(AR_CONST.NDCBalacedFailed);
              }
            });
          }
        }
        setLoad(false);
      });
    }
  };

  const handleUndoDeclareNDCBalanced = (row) => {
    if (row) {
      if (
        singleNdcDetailList.invoiceStatus === 'DB' ||
        singleNdcDetailList.invoiceStatusCd === 'DB'
      ) {
        // show confirmation popup
        setConfimPopup(true);
        setConfirmPopupData({
          callFrom: 'undoNDCBalanced',
          popupText: AR_CONST.undoNDCBalancedConfirmMsg,
        });
        setUndoData(singleNdcDetailList);
      } else if (row.data?.status !== 'DB') {
        setIsDialogOpen(true);
        setDialogText(AR_CONST.undoNDCDrugMsg);
      } else {
        setLoad(true);
        // API call fn : undoDeclareNDCBalanced
        const payload = {
          drugSeqNum: row.data.drugSeqNum,
          startQtr:
            singleNdcDetailList?.getQuarterValue || singleNdcDetailList?.qtr,
          rebatePrgogramCd: singleNdcDetailList?.pgmCd,
          contractSequenceNum: row.data.contractSeqNum,
          invoiceNum: singleNdcDetailList?.invoiceNum,
          statusCd: row.data.status,
          isUndoDeclareInvoice: 'N',
          labelerCd: row.data.productCd,
          // asTypeCd: 'DB',
        };
        undoDeclareNDCBalanced(payload).then((res) => {
          if (res && res.data.status === '001') {
            setIsDialogOpen(true);
            if (res.data.reponse.ndcStatus) {
              setDialogText(AR_CONST.undoNDCCompleted);
              const updatedStatusData =
                NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO.map(
                  (item) => {
                    if (item.drugSeqNum === row.data.drugSeqNum)
                      item.status = res.data.reponse.ndcStatus;
                    return item;
                  }
                );

              const updateData = {
                ...NDCDetail,
                acctRecvMfgNDCDetaillSingleServiceResonse: {
                  ...NDCDetail.acctRecvMfgNDCDetaillSingleServiceResonse,
                  acctRecvMfgNDCDetailSingleRpcResponseVO: updatedStatusData,
                },
              };
              setNDCDetailTableData(
                JSON.parse(JSON.stringify(updatedStatusData))
              );
              dispatch(
                singleAccRecNDCDetail(
                  JSON.parse(JSON.stringify({ [activepgmCode]: updateData }))
                )
              );
              if (gridApi) gridApi.api.refreshCells();
            } else {
              setDialogText(res.data.reponse.responseMessage);
            }
          } else {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.undoNDCFailed);
          }
          setLoad(false);
        });
      }
    }
  };

  const undoInvoiceBalancedHandler = (data) => {
    if (data.invoiceStatusCd === 'FG') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoForgivenMsg);
    } else if (data.invoiceStatusCd === 'WO') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoWrittenOff);
    } else {
      setLoad(true);
      const payloadData = {
        invoiceStatusCd: data.invoiceStatusCd || data.invoiceStatus,
        invoiceNum: data.invoiceNum,
        rebateProgramCd: data?.pgmCd,
        invoiceQtr: data.getQuarterValue || data.qtr,
      };

      undoInvoiceBalanced(payloadData).then((res) => {
        if (res && res.data.response) {
          const updatedStatusData =
            NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO.map(
              (item) => {
                item.status = res.data.response.invoiceStatus;
                return item;
              }
            );

          const updateData = {
            ...NDCDetail,
            acctRecvMfgNDCDetaillSingleServiceResonse: {
              ...NDCDetail.acctRecvMfgNDCDetaillSingleServiceResonse,
              acctRecvMfgNDCDetailSingleRpcResponseVO: updatedStatusData,
            },
          };

          dispatch(
            singleAccRecNDCDetail(
              JSON.parse(JSON.stringify({ [activepgmCode]: updateData }))
            )
          );
          // if (gridApi) gridApi.api.refreshCells();

          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedFailed);
        }
        setLoad(false);
      });
    }
  };

  // estimate principal due
  const handleEstimatePrincipalDue = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        drugSeqNum: row.drugSeqNum,
        qtr: singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebateProgramCd: singleNdcDetailList?.pgmCd,
      };
      getDrugQtrDetails(payload).then((drguQtrDetail) => {
        if (drguQtrDetail) {
          setLoad(false);
          setEstPriDue(true);
          setDrugQtrDetail(drguQtrDetail);
        }
      });
    }
  };

  const handleModifyUnitsFromAR = (row) => {
    if (row) {
      setLoad(true);
      getInvoiceDetails(singleNdcDetailList.invoiceNum).then((invDtl) => {
        if (invDtl) {
          if (!invDtl?.invoiceFreezeDt) {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.modifyUnitsFrozenMsg);
          } else if (row.productCd === 'ADJS') {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.modifyUnitsProductCDMsg);
          } else {
            setLoad(true);
            const payload = {
              drugSeqNum: row.drugSeqNum,
              qtr:
                singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
              rebateProgramCd: singleNdcDetailList?.pgmCd,
            };
            getDrugQtrDetails(payload).then((drguQtrDetail) => {
              if (drguQtrDetail) {
                setLoad(false);
                setModifyUnitsPopup(true);
                setDrugQtrDetail(drguQtrDetail);
                setModifyUnitsRowData(row);
              }
            });
          }
        }
        setLoad(false);
      });
    }
  };

  const modifyUnitsPopupComponent = () => {
    return (
      <div className="ml-4 frr-ar-custom-font">
        <div className="dif">
          <label>Current URA:</label>
          <p style={{ marginLeft: '10px', color: 'grey' }}>
            {drugQtrDetail?.unitRebateAmt}
          </p>
        </div>
        <div className="dif">
          <label>Current Units:</label>
          <p style={{ marginLeft: '7px', color: 'grey' }}>
            {drugQtrDetail?.numOfUnits}
          </p>
        </div>
        <div className="dif">
          <label>Paid Amount:</label>
          <p style={{ marginLeft: '10px ', color: 'grey' }}>
            {` $ ${drugQtrDetail?.paidAmt}`}
          </p>
        </div>
        <div className="dif">
          <label>Principal Due:</label>
          {calculatePriDue === null ? (
            <p style={{ marginLeft: '9px', color: 'grey' }}>
              {` $ ${
                drugQtrDetail?.principalDue || drugQtrDetail?.principalDue == 0
                  ? parseFloat(drugQtrDetail?.principalDue).toFixed(2)
                  : drugQtrDetail?.principalDue
              }`}
            </p>
          ) : null}
          {calculatePriDue != null ? (
            <p style={{ marginLeft: '9px', color: 'grey' }}>
              {` $ ${parseFloat(calculatePriDue).toFixed(2)}`}
            </p>
          ) : null}
        </div>
        <div>
          <div className="mui-custom-form ml-0">
            <TextField
              id="numUnits"
              label={numUnitsLabel}
              placeholder=""
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                const numReg = /^[0-9]*\.?[0-9]*$/;
                if (e.target.value === '' || numReg.test(e.target.value)) {
                  setNumOfUnitsValue(e.target.value);
                }
              }}
              inputProps={{ maxLength: 20 }}
              value={numOfUnitsValue}
              data-testid="numUnits"
            />
          </div>
        </div>
      </div>
    );
  };

  // Override Interest
  const handleOverrideInterest = (row) => {
    if (row) {
      setLoad(true);
      getInvoiceDetails(singleNdcDetailList.invoiceNum).then((invDtl) => {
        if (invDtl) {
          if (!invDtl?.invoiceFreezeDt) {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.overrideInterestFrozenErr);
          } else if (row.productCd === 'ADJS') {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.overrideInterestProdCodeErr);
          } else {
            setLoad(true);
            const payload = {
              drugSeqNum: row.drugSeqNum,
              qtr:
                singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
              rebateProgramCd: singleNdcDetailList?.pgmCd,
            };
            getDrugQtrDetails(payload).then((drguQtrDetail) => {
              if (drguQtrDetail) {
                setLoad(false);
                setDrugQtrDetail(drguQtrDetail);
                setOverridePopupData({ showPopup: true, data: row });
              }
            });
          }
        }
        setLoad(false);
      });
    }
  };

  const handleOkOverrideInterest = () => {
    const currentInterestDue = parseFloat(overridePopupData?.data?.interestDue);
    const enteredInterestDue = parseFloat(interestDue);

    if (
      interestDue === '' ||
      interestDue === null ||
      interestDue === undefined
    ) {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.overrideInterestReqErr);
    } else if (
      !Number.isNaN(currentInterestDue) &&
      !Number.isNaN(enteredInterestDue) &&
      currentInterestDue === enteredInterestDue
    ) {
      // Compare against currently displayed Interest Due (latest overridden value)
      setIsDialogOpen(true);
      setDialogText(AR_CONST.overrideInterestDiffErr);
    } else {
      setLoad(true);
      const payload = {
        invoiceNum: singleNdcDetailList.invoiceNum,
        drugSeqNum: overridePopupData?.data?.drugSeqNum,
        quarter: singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebateProgram: singleNdcDetailList?.pgmCd,
        contractSequenceNum: overridePopupData?.data?.contractSeqNum,
        dqdStatus: drugQtrDetail?.statusCd, // need confirmation
        currentUnits: overridePopupData?.data?.currentUnits,
        paidUnits: drugQtrDetail?.paidUnits,
        unPaidUnits: drugQtrDetail?.unpaidUnits,
        newUnits: 0,
        disputedUnits: drugQtrDetail?.disputedUnits,
        interestDue: interestDue,
        principalDue: overridePopupData?.data?.principalDue,
        currentUra: overridePopupData?.data?.currentURA,
        drugLabelerCode: overridePopupData?.data?.labelerCode,
        userId: logInUser,
      };
      overrideInterestFromAR(payload).then(async (response) => {
        if (response?.data?.status === '001') {
          // Refresh grid so Interest Due / Total Due update at row and totals
          const refreshPayload = {
            mfgId: singleNdcDetailList?.mfgId,
            startQuarter:
              singleNdcDetailList?.getQuarterValue || singleNdcDetailList?.qtr,
            aiUseOfficialURA: singleNdcDetailList?.useOfficialURA,
            invoiceNumber: singleNdcDetailList?.invoiceNum,
            rebateProgramCd: singleNdcDetailList?.pgmCd,
          };
          const refreshedData = await dispatch(
            getRefreshTableData(refreshPayload)
          );
          dispatch(
            singleAccRecNDCDetail(
              JSON.parse(JSON.stringify({ [activepgmCode]: refreshedData }))
            )
          );

          // Update Modification from AR
          const isDrugModified = [...modificationFromAr].some(
            (item) => item.drugSeqNum === overridePopupData?.data?.drugSeqNum
          );
          let modificationFromARUpdate = [];
          if (isDrugModified) {
            modificationFromARUpdate = modificationFromAr.map((item) => {
              if (item.drugSeqNum === overridePopupData?.data?.drugSeqNum) {
                item.interest = true;
              }
              return item;
            });
          } else {
            modificationFromARUpdate = [
              ...modificationFromAr,
              {
                drugSeqNum: overridePopupData?.data?.drugSeqNum,
                unit: false,
                interest: true,
              },
            ];
          }
          dispatch(dispatchModificationFromAr(modificationFromARUpdate));

          handleCloseOverridePopup();
        } else {
          handleCloseOverridePopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.overrideInterestFailed);
        }
        setLoad(false);
      });
    }
  };

  const overrideInterestPopupComponent = () => {
    return (
      <div className="frr-ar-custom-font ml-4">
        <div className="dif">
          <label>NDC:</label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {overridePopupData?.data?.ndc}
          </p>
        </div>
        <div className="dif">
          <label>Drug Name:</label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {overridePopupData?.data?.drugName}
          </p>
        </div>
        <div className="dif">
          <label>Interest Calculated:</label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {` $ ${overridePopupData?.data?.interestCalculated}`}
          </p>
        </div>
        <div className="dif">
          <label>Interest Paid:</label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {` $ ${overridePopupData?.data?.interestPaid}`}
          </p>
        </div>
        <div className="dif">
          <label>Current Interest Due:</label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {` $ ${overridePopupData?.data?.interestDue}`}
          </p>
        </div>
        <div>
          <div className="mui-custom-form ml-0">
            <TextField
              id="interestDue"
              label={interestDueLabel}
              placeholder=""
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                const numReg = /^[0-9]*\.?[0-9]*$/;
                if (e.target.value === '' || numReg.test(e.target.value)) {
                  setInterestDue(e.target.value);
                }
              }}
              inputProps={{ maxLength: 20 }}
              value={interestDue}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleCloseOverridePopup = () => {
    setOverridePopupData((prev) => {
      return { ...prev, showPopup: false, data: null };
    });
    setInterestDue('');
    setDrugQtrDetail([]);
  };

  // Set units to claims
  const handleSetUnitsToClaims = (row) => {
    if (row) {
      setLoad(true);
      getInvoiceDetails(singleNdcDetailList.invoiceNum).then((invDtl) => {
        if (invDtl) {
          if (!invDtl?.invoiceFreezeDt) {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.setUnitsFrozenErr);
          } else if (row.productCd === 'ADJS') {
            setIsDialogOpen(true);
            setDialogText(AR_CONST.setUnitsProductCDMsg);
          } else {
            setLoad(true);

            // DQD table API
            const dqdPayload = {
              drugSeqNum: row.drugSeqNum,
              qtr:
                singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
              rebateProgramCd: singleNdcDetailList?.pgmCd,
            };
            const getDrugQtrDetailsPromise = getDrugQtrDetails(dqdPayload);

            // units to claims API
            const unitsToClaimPayload = {
              isClaimRpc: singleNdcDetailList?.pgmCd,
              startQtr:
                singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
              rebateProgram: singleNdcDetailList?.pgmCd,
              drugSeqNum: row.drugSeqNum,
              mfgId: singleNdcDetailList?.mfgId,
            };
            const setUnitsToClaimOnloadPromise =
              setUnitsToClaimOnload(unitsToClaimPayload);

            Promise.all([
              getDrugQtrDetailsPromise,
              setUnitsToClaimOnloadPromise,
            ]).then((res) => {
              setLoad(false);

              let [dqdResponse, unitsToClaimResponse] = res;
              if (dqdResponse && unitsToClaimResponse) {
                // Calculate Principal Due
                const principalDue = Math.round(
                  dqdResponse.unitRebateAmt *
                    unitsToClaimResponse?.data
                      ?.acctRecvbyMfgSetUnitstoClaimOnLoadResponseVO.unitCount -
                    dqdResponse.paidAmt,
                  2
                );
                dqdResponse = { ...dqdResponse, principalDue: principalDue };

                const unitsPopupData = {
                  rowData: row,
                  dqdResponseData: dqdResponse,
                  unitsToClaimResponseData:
                    unitsToClaimResponse?.data
                      ?.acctRecvbyMfgSetUnitstoClaimOnLoadResponseVO,
                };
                setSetUnitsPopupData((prev) => {
                  return {
                    ...prev,
                    data: unitsPopupData,
                  };
                });

                const totalUnits =
                  unitsToClaimResponse?.data
                    ?.acctRecvbyMfgSetUnitstoClaimOnLoadResponseVO?.unitCount;
                if (totalUnits === 0) {
                  setNoClaimPopup({
                    show: true,
                    msg: AR_CONST.setUnitsNoClaimsFound,
                  });
                } else {
                  setLoad(false);

                  setSetUnitsPopupData((prev) => {
                    return { ...prev, showPopup: true };
                  });
                }
              }

              setLoad(false);
            });
          }
        }
        setLoad(false);
      });
    }
  };

  const handleOkSetUnitsToClaims = () => {
    setLoad(true);
    if (
      setUnitsPopupData?.data?.dqdResponseData?.numOfUnits ==
      setUnitsPopupData?.data?.unitsToClaimResponseData?.unitCount
    ) {
      handleClosesetUnitsPopup();
      setLoad(false);
    } else {
      const payload = {
        popUpMode: 'SET_UNITS',
        invoiceNum: singleNdcDetailList.invoiceNum,
        drugSeqNum: setUnitsPopupData?.data?.rowData?.drugSeqNum,
        quarter: singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebateProgram: singleNdcDetailList?.pgmCd,
        contractSequenceNum:
          setUnitsPopupData?.data?.dqdResponseData?.contractSeqNum,
        unitsModifiedIndicator: 1,
        dqdStatus: setUnitsPopupData?.data?.dqdResponseData?.statusCd,
        currentUnits: setUnitsPopupData?.data?.dqdResponseData?.numOfUnits,
        paidUnits: setUnitsPopupData?.data?.dqdResponseData?.paidUnits,
        unPaidUnits: setUnitsPopupData?.data?.dqdResponseData?.unpaidUnits,
        newUnits: setUnitsPopupData?.data?.unitsToClaimResponseData?.newUnits,
        disputedUnits: setUnitsPopupData?.data?.dqdResponseData?.disputedUnits,
        interestDue: setUnitsPopupData?.data?.dqdResponseData?.interestDue,
        principalDue: setUnitsPopupData?.data?.dqdResponseData?.principalDue,
        currentUra: setUnitsPopupData?.data?.dqdResponseData?.unitRebateAmt,
        drugLabelerCode: setUnitsPopupData?.data?.rowData?.labelerCode,
        csStatus: 'XXX',
        tplAmount: setUnitsPopupData?.data?.unitsToClaimResponseData?.tplAmt,
        coPayAmount:
          setUnitsPopupData?.data?.unitsToClaimResponseData?.copayAmt,
        deductibleAmount:
          setUnitsPopupData?.data?.unitsToClaimResponseData?.deductibleAmt,
        totalReimbursedAmount:
          setUnitsPopupData?.data?.unitsToClaimResponseData?.totReimbursedAmt,
        numOfPrescriptions:
          setUnitsPopupData?.data?.unitsToClaimResponseData?.totReimbursedAmt,
        userId: logInUser,
      };
      setLoad(true);
      modifyUnitsFromAcctRecv(payload).then(async (res) => {
        if (res?.data?.status === '001') {
          // Refresh Logic
          // const updatedStatusData =
          //   NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO.map(
          //     (item) => {
          //       if (
          //         item.drugSeqNum ===
          //         setUnitsPopupData?.data?.rowData?.drugSeqNum
          //       )
          //         item.currentUnits =
          //           setUnitsPopupData?.data?.unitsToClaimResponseData?.unitCount;
          //       return item;
          //     }
          //   );
          // const updateData = {
          //   ...NDCDetail,
          //   acctRecvMfgNDCDetaillSingleServiceResonse: {
          //     ...NDCDetail.acctRecvMfgNDCDetaillSingleServiceResonse,
          //     acctRecvMfgNDCDetailSingleRpcResponseVO: updatedStatusData,
          //   },
          // };
          const payload = {
            mfgId: singleNdcDetailList?.mfgId,
            startQuarter:
              singleNdcDetailList?.getQuarterValue || singleNdcDetailList?.qtr,
            aiUseOfficialURA: singleNdcDetailList?.useOfficialURA,
            invoiceNumber: singleNdcDetailList?.invoiceNum,
            rebateProgramCd: singleNdcDetailList?.pgmCd,
          };
          let response = await dispatch(getRefreshTableData(payload));
          dispatch(
            singleAccRecNDCDetail(
              JSON.parse(JSON.stringify({ [activepgmCode]: response }))
            )
          );

          handleClosesetUnitsPopup();
          setLoad(false);
        } else {
          handleClosesetUnitsPopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.modifyunitFailed);
          setLoad(false);
        }
      });
    }
  };

  const handleClosesetUnitsPopup = () => {
    setSetUnitsPopupData((prev) => {
      return { ...prev, showPopup: false, data: null };
    });
  };

  const setUnitsPopupComponent = () => {
    return (
      <div className="frr-ar-custom-font ml-4">
        <div className="dif">
          <label>Current URA:</label>
          <p style={{ marginLeft: '10px', color: 'grey' }}>
            {setUnitsPopupData?.data?.dqdResponseData?.unitRebateAmt}
          </p>
        </div>
        <div className="dif">
          <label>Current Units:</label>
          <p style={{ marginLeft: '7px', color: 'grey' }}>
            {setUnitsPopupData?.data?.dqdResponseData?.numOfUnits}
          </p>
        </div>
        <div className="dif">
          <label>Paid Amount:</label>
          <p style={{ marginLeft: '9px', color: 'grey' }}>
            {` $ ${setUnitsPopupData?.data?.dqdResponseData?.paidAmt}`}
          </p>
        </div>
        <div className="dif">
          <label>Principal Due:</label>
          <p style={{ marginLeft: '7px', color: 'grey' }}>
            {` $ ${
              setUnitsPopupData?.data?.dqdResponseData?.principalDue ||
              setUnitsPopupData?.data?.dqdResponseData?.principalDue == 0
                ? parseFloat(
                    setUnitsPopupData?.data?.dqdResponseData?.principalDue
                  ).toFixed(2)
                : setUnitsPopupData?.data?.dqdResponseData?.principalDue
            }`}
          </p>
        </div>
        <div className="dif">
          <label>Num of Units From Claims: </label>
          <p style={{ marginLeft: '2px', color: 'grey' }}>
            {setUnitsPopupData?.data?.unitsToClaimResponseData?.newUnits }
          </p>
        </div>
      </div>
    );
  };
  const commentsCallFn = async () => {
    const val =
      NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.map(
        (o) => o.corrLinkId
      );
    const result = await dispatch(getExistingCorrLinkIds(val));
    const newVal =
      NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.map(
        (obj) => {
          obj.commentsExist = 0;
          if (result.indexOf(obj.corrLinkId) !== -1) obj.commentsExist = 1;
          return obj;
        }
      );
    const updateData = {
      ...NDCDetail,
      acctRecvMfgNDCDetaillSingleServiceResonse: {
        ...NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse,
        acctRecvMfgNDCDetailSingleRpcResponseVO: newVal,
      },
    };
    dispatch(singleAccRecNDCDetail({ [activepgmCode]: updateData }));

    setFlag(true);
    // setTimeout(() => {
    // if (gridApi) gridApi.redrawRows();
    // }, 0);
  };
  React.useEffect(() => {
    if (flag && gridApi) {
      gridApi.redrawRows();
      setFlag(false);
    }
  }, [flag]);

  // ag-grid frame work component
  const frameworkComponents = {
    ActionRenderer: (cellInfo) => {
      return (
        <>
          <div className="tdCell dib icon-btn-group">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
            >
              <Button
                onClick={() => commentsData(true, cellInfo.data.corrLinkId)}
                variant="text"
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn"
              >
                {parseInt(cellInfo.data.commentsExist, [0, 1]) === 0 ? (
                  <SVGComponent iconName="Icon-comment-grey" />
                ) : (
                  <SVGComponent iconName="Icon-comment" />
                )}
              </Button>
            </OverlayTrigger>
          </div>
          <ActionDropDownComp
            data={cellInfo}
            loadfn={setLoad}
            displayBy="ndcdetail"
            selectPgm={false}
            extraData={{
              ...singleNdcDetailList,
              quarter:
                singleNdcDetailList?.getQuarterValue ||
                singleNdcDetailList?.qtr,
            }}
            handleUndoDeclareNDCBalanced={handleUndoDeclareNDCBalanced}
            handleDeclareNDCBalanced={handleDeclareNDCBalanced}
            handleShowDrugActivity={handleShowDrugActivity}
            handleModifyUnitsFromAR={handleModifyUnitsFromAR}
            handleEstimatePrincipalDue={handleEstimatePrincipalDue}
            handleOverrideInterest={handleOverrideInterest}
            handleSetUnitsToClaims={handleSetUnitsToClaims}
          />
        </>
      );
    },
    FullNameRender: (cellInfo) => {
      return <NameTooltipComp data={cellInfo} />;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    NameTextRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return cellInfo.value;
    },
    NegativeRed: (cellInfo) => {
      let value = '';
      if (cellInfo?.colDef?.headerName === 'Units Disputed') {
        value = cellInfo.data.unitsDisputed;
      }
      if (cellInfo?.colDef?.headerName === 'Units Unpaid') {
        value = cellInfo.data.unitsUnpaid;
      }
      if (cellInfo?.colDef?.headerName === 'Units Paid') {
        value = cellInfo.data.unitsPaid;
      }
      if (cellInfo?.colDef?.headerName === 'Current Units') {
        value = cellInfo.data.currentUnits;
      }
      if (cellInfo?.colDef?.headerName === 'Original Units') {
        value = cellInfo.data.originalUnits;
      }
      if (value && parseFloat(value) < 0)
        return (
          <span style={{ color: '#eb0000' }}>
            ({parseFloat(-value).toFixed(3)})
          </span>
        );
      if (cellInfo?.data?.isBottomRow) {
        return (
          <span>
            <b>{value}</b>
          </span>
        );
      }
      return <span>{value}</span>;
    },
    CheckboxRenderer: (cellInfo) => {
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            value={
              cellInfo.data.familyPlanningindicator === 0
                ? false
                : true || false
            }
            disabled
            onChange={(e, val) => {}}
            checked={
              cellInfo.data.familyPlanningindicator === 0
                ? false
                : true || false
            }
          />
        </div>
      );
    },
  };

  React.useEffect(() => {
    if (!ndcDetailFirstLoad) {
      commentsCallFn();
      dispatch(ndcDetailFirstLoadAction(true));
      if (userDefaults) {
        userDefaults?.dispBalanceDueNdcInd == 1
          ? dispatch(dispatchNDCBalanceDue({ [activepgmCode]: true }))
          : dispatch(dispatchNDCBalanceDue({ [activepgmCode]: false }));
        userDefaults?.dispOverriddenNdcInd == 1
          ? dispatch(dispatchNDCOveridden({ [activepgmCode]: true }))
          : dispatch(dispatchNDCOveridden({ [activepgmCode]: false }));
        userDefaults?.dispPaidInFullNdcInd == 1
          ? dispatch(dispatchNDCPaidInFull({ [activepgmCode]: true }))
          : dispatch(dispatchNDCPaidInFull({ [activepgmCode]: false }));
      }
    }
    setLoad(false);
  }, []);

  // on grid ready for table
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // filter checkbox on change event
  const handleOnChangeEvent = (value, name) => {
    if (value === 1 && name === 'balanceDue') {
      dispatch(
        dispatchNDCBalanceDue({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(true, getOverridden, getPaidInFull);
    } else if (value === 0 && name === 'balanceDue') {
      dispatch(
        dispatchNDCBalanceDue({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(false, getOverridden, getPaidInFull);
    } else if (value === 1 && name === 'overridden') {
      dispatch(
        dispatchNDCOveridden({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, true, getPaidInFull);
    } else if (value === 0 && name === 'overridden') {
      dispatch(
        dispatchNDCOveridden({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, false, getPaidInFull);
    } else if (value === 1 && name === 'paidinfull') {
      dispatch(
        dispatchNDCPaidInFull({
          [activepgmCode]: true,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, getOverridden, true);
    } else if (value === 0 && name === 'paidinfull') {
      dispatch(
        dispatchNDCPaidInFull({
          [activepgmCode]: false,
        })
      );
      applyFilterForInvoiceBlns(getBalnceDue, getOverridden, false);
    }
  };
  // apply filters while check on checkbox
  const applyFilterForInvoiceBlns = (bl, ov, pf) => {
    let data = [];
    if (bl === false && ov === false && pf === true) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) => obj.status === 'PIF'
        );
    } else if (bl === false && ov === true && pf === true) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) =>
            obj.status === 'PIF' ||
            obj.status === 'WO' ||
            obj.status === 'FG' ||
            obj.status === 'DB' ||
            obj.status === 'DBK'
        );
    } else if (bl === true && ov === false && pf === true) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) =>
            obj.status != 'WO' &&
            obj.status != 'FG' &&
            obj.status != 'DB' &&
            obj.status != 'DBK'
        );
    } else if (bl === false && ov === false && pf === false) {
      data = [];
    } else if (bl === false && ov === true && pf === false) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) =>
            obj.status === 'WO' ||
            obj.status === 'FG' ||
            obj.status === 'DB' ||
            obj.status === 'DBK'
        );
    } else if (bl === true && ov === false && pf === false) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) =>
            obj.status != 'PIF' &&
            obj.status != 'WO' &&
            obj.status != 'FG' &&
            obj.status != 'DB' &&
            obj.status != 'DBK'
        );
    } else if (bl === true && ov === true && pf === false) {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO?.filter(
          (obj) => obj.status != 'PIF'
        );
    } else {
      data =
        NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
          ?.acctRecvMfgNDCDetailSingleRpcResponseVO;
    }
    data =
      data?.length > 0
        ? data.map((obj) => {
            obj.bgHighlighterColor = getBgHighlighterColor(obj);
            return obj;
          })
        : [];

    setFilterApply(data?.length > 0);
    setFilteredRow(JSON.parse(JSON.stringify(data)));
    setNDCDetailTableData(JSON.parse(JSON.stringify(data)));
  };
  // apply default filters
  React.useEffect(() => {
    applyFilterForInvoiceBlns(getBalnceDue, getOverridden, getPaidInFull);
  }, [NDCDetail, getBalnceDue, getOverridden, getPaidInFull]);

  // calculate estimate principal due
  const calculateEstPriDue = () => {
    if (numOfUnitsValue) {
      const calPriDue =
        drugQtrDetail?.unitRebateAmt * numOfUnitsValue - drugQtrDetail?.paidAmt;
      setCalculatePriDue(calPriDue);
      setNumOfUnitsValue(Number(numOfUnitsValue).toFixed(2));
    } else {
      setIsDialogOpen(true);
      setDialogText(principalDueError);
    }
  };

  const closeModifyUnitsPopup = () => {
    setModifyUnitsPopup(false);
    setCalculatePriDue(null);
    setNumOfUnitsValue('');
    setDrugQtrDetail([]);
  };

  const handleOkModifyUnitsFromAR = () => {
    if (!numOfUnitsValue) {
      setIsDialogOpen(true);
      setDialogText(principalDueError);
    } else if (drugQtrDetail?.numOfUnits == numOfUnitsValue) {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.modifyUnitsErr);
    } else {
      setLoad(true);
      const principalDueForSave =
        calculatePriDue != null
          ? calculatePriDue
          : drugQtrDetail?.unitRebateAmt * numOfUnitsValue -
            drugQtrDetail?.paidAmt;
      const payload = {
        popUpMode: 'MODIFY_UNITS',
        invoiceNum: singleNdcDetailList.invoiceNum,
        drugSeqNum: modifyUnitsRowData?.drugSeqNum,
        quarter: singleNdcDetailList.getQuarterValue || singleNdcDetailList.qtr,
        rebateProgram: singleNdcDetailList?.pgmCd,
        contractSequenceNum: modifyUnitsRowData?.contractSeqNum,
        unitsModifiedIndicator: 0,
        dqdStatus: drugQtrDetail?.statusCd, // need confirmation
        currentUnits: modifyUnitsRowData?.currentUnits,
        paidUnits: modifyUnitsRowData?.unitsPaid,
        unPaidUnits: modifyUnitsRowData?.unitsUnpaid,
        newUnits: numOfUnitsValue, // Need confirmation
        disputedUnits: modifyUnitsRowData?.unitsDisputed,
        interestDue: modifyUnitsRowData?.interestDue,
        principalDue: principalDueForSave,
        currentUra: modifyUnitsRowData?.currentURA,
        drugLabelerCode: modifyUnitsRowData?.labelerCode,
        csStatus: 'XXX',
        tplAmount: drugQtrDetail?.tplAmt,
        coPayAmount: drugQtrDetail?.copayAmt,
        deductibleAmount: drugQtrDetail?.deductibleAmt,
        totalReimbursedAmount: drugQtrDetail?.totReimbursedAmt,
        numOfPrescriptions: drugQtrDetail?.numOfPrescriptions,
        userId: logInUser,
      };
      modifyUnitsFromAcctRecv(payload).then(async (res) => {
        if (res?.data?.status === '001') {
          // Refresh Logic
          // const updatedStatusData =
          //   NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse?.acctRecvMfgNDCDetailSingleRpcResponseVO.map(
          //     (item) => {
          //       if (item.drugSeqNum === modifyUnitsRowData.drugSeqNum)
          //         item.currentUnits = numOfUnitsValue;
          //       return item;
          //     }
          //   );
          // const updateData = {
          //   ...NDCDetail,
          //   acctRecvMfgNDCDetaillSingleServiceResonse: {
          //     ...NDCDetail.acctRecvMfgNDCDetaillSingleServiceResonse,
          //     acctRecvMfgNDCDetailSingleRpcResponseVO: updatedStatusData,
          //   },
          // };
          const uraFlag = singleNdcDetailList?.useOfficialURA;
          const aiUseOfficialURA =
            uraFlag === 1 || uraFlag === '1' || uraFlag === 'Official'
              ? 1
              : uraFlag === 0 || uraFlag === '0'
              ? 0
              : singleNdcDetailList?.uraInfo === 'Official'
              ? 1
              : 0;
          const payload = {
            mfgId: singleNdcDetailList?.mfgId,
            startQuarter:
              singleNdcDetailList?.getQuarterValue || singleNdcDetailList?.qtr,
            aiUseOfficialURA,
            invoiceNumber: singleNdcDetailList?.invoiceNum,
            rebateProgramCd: singleNdcDetailList?.pgmCd,
          };
          let response = await dispatch(getRefreshTableData(payload));
          dispatch(
            singleAccRecNDCDetail(
              JSON.parse(JSON.stringify({ [activepgmCode]: response }))
            )
          );

          // Update Modification from AR
          const isDrugModified = [...modificationFromAr].some(
            (item) => item.drugSeqNum === modifyUnitsRowData?.drugSeqNum
          );
          let modificationFromARUpdate = [];
          if (isDrugModified) {
            modificationFromARUpdate = modificationFromAr.map((item) => {
              if (item.drugSeqNum === modifyUnitsRowData?.drugSeqNum) {
                item.unit = true;
              }
              return item;
            });
          } else {
            modificationFromARUpdate = [
              ...modificationFromAr,
              {
                drugSeqNum: modifyUnitsRowData?.drugSeqNum,
                unit: true,
                interest: false,
              },
            ];
          }
          dispatch(dispatchModificationFromAr(modificationFromARUpdate));

          closeModifyUnitsPopup();
          setLoad(false);
        } else {
          closeModifyUnitsPopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.modifyunitFailed);
          setLoad(false);
        }
      });
    }
  };
  const customPDFExport = (fileName) => {
    const reportName = accountReceivableNDCDatailLabel;
    const resultData = filterApply ? filteredRows : NDCDetailTBData;
    const rowdata =
      (resultData &&
        resultData?.map((item) => {
          item.originalUnits = item.originalUnits
            ? parseFloat(item.originalUnits).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.currentUnits = item.currentUnits
            ? parseFloat(item.currentUnits).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsPaid = item.unitsPaid
            ? parseFloat(item.unitsPaid).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsUnpaid = item.unitsUnpaid
            ? parseFloat(item.unitsUnpaid).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsDisputed = item.unitsDisputed
            ? parseFloat(item.unitsDisputed).toFixed(3)
            : parseFloat(0).toFixed(3);
          return item;
        })) ||
      [];
    const columns = accountReceivableNDCDetailColumns;

    const customObj = {
      rebateProgramName: singleNdcDetailList?.pgmInfo,
      mfgId: singleNdcDetailList && singleNdcDetailList.mfgId,
      mfgName: singleNdcDetailList.mfgName,
      quarter: singleNdcDetailList?.getQuarterValue || singleNdcDetailList?.qtr,
      invoiceDate: singleNdcDetailList?.invoiceDate,
      InvoiceNumber: singleNdcDetailList?.invoiceNum,
      invoiceStatus:
        singleNdcDetailList?.invoiceStatus ||
        singleNdcDetailList?.invoiceStatusCd,
      URAUsed: singleNdcDetailList?.uraInfo,
    };
    const pinnedBottomRowData =
      NDCDetail?.acctRecvMfgNDCDetaillSingleServiceResonse
        ?.acctRecvMfgNDCDetailSingleRpcResponseVO?.length > 0
        ? pinned
        : undefined;

    const NDCBalance = {
      balanceDue: getBalnceDue,
      overidden: getOverridden,
      paidInFull: getPaidInFull,
    };
    exportPDF(
      rowdata,
      fileName,
      logInUser,
      columns,
      customObj,
      NDCBalance,
      pinnedBottomRowData,
      reportName,
      dispatch
    );
  };
  const activeInvNum = singleNdcDetailList?.invoiceNum;
  const activeCheckLogNum = singleNdcDetailList?.checkLogNum;

  const pqasGridLevelActions = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.pqasGridLevelActions[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  return (
    <div className="tabs-container ARScreen" data-testid="AccRecNDCDetail">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2={`Accounts Receivable NDC Detail [${singleNdcDetailList?.pgmCd}]`}
      />
      {!fullScreenView && (
        <div className="row">
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="manufacturerId"
                      label={manufacturerIdLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={singleNdcDetailList && singleNdcDetailList.mfgId}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="name"
                      label={nameLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={singleNdcDetailList && singleNdcDetailList.mfgName}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="quarter"
                      label={quarterRangeLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        pqasGridLevelActions?.pgQtrVal ||
                        singleNdcDetailList?.qtr ||
                        singleNdcDetailList?.getQuarterValue
                      }
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={singleNdcDetailList?.pgmInfo}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={singleNdcDetailList?.uraInfo}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="invoiceStatus"
                      label={invoiceStatusLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        singleNdcDetailList?.invoiceStatus ||
                        singleNdcDetailList?.invoiceStatusCd
                      }
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="invoiceNumber"
                      label={invoiceNumberLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={singleNdcDetailList?.invoiceNum}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="invoiceDate"
                      label={invoiceDateLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={
                        singleNdcDetailList?.invoiceDate
                          ? moment.utc(singleNdcDetailList?.invoiceDate).format(
                              'MM/DD/YYYY'
                            )
                          : ''
                      }
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-12 col-sm-12 col-md-8 mt-3">
            <fieldset className="custom-fieldset w-100  px-4 d-flex align-items-center ">
              <legend>NDC Balance</legend>
              <FormControlLabel
                className="ml-0 "
                data-testid="checked_ia"
                id="checked_ia"
                control={<Checkbox color="primary" className="mr-2" />}
                label={balanceDueLabel}
                value={getBalnceDue}
                checked={getBalnceDue}
                onChange={(e) => {
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'balanceDue');
                }}
              />
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia1"
                id="checked_ia1"
                control={
                  <Checkbox
                    color="primary"
                    className="mr-2"
                    checked={getOverridden}
                  />
                }
                label={overriddenLabel}
                value={getOverridden}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'overridden')
                }
              />
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia2"
                id="checked_ia2"
                control={
                  <Checkbox
                    color="primary"
                    className="mr-2"
                    checked={getPaidInFull}
                  />
                }
                label={paidInFullLabel}
                value={getPaidInFull}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked ? 1 : 0, 'paidinfull')
                }
              />
            </fieldset>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={accountReceivableNDCDetailColumns?.map((item) => {
              if (item.field === 'commentsExist') {
                item.headerName = 'Comments Exists';
              }
              return item;
            })}
            rowData={
              NDCDetailTBData?.map((item) => {
                item.originalUnits = item.originalUnits
                  ? parseFloat(item.originalUnits).toFixed(3)
                  : parseFloat(0).toFixed(3);
                item.currentUnits = item.currentUnits
                  ? parseFloat(item.currentUnits).toFixed(3)
                  : parseFloat(0).toFixed(3);
                item.unitsPaid = item.unitsPaid
                  ? parseFloat(item.unitsPaid).toFixed(3)
                  : parseFloat(0).toFixed(3);
                item.unitsUnpaid = item.unitsUnpaid
                  ? parseFloat(item.unitsUnpaid).toFixed(3)
                  : parseFloat(0).toFixed(3);
                item.unitsDisputed = item.unitsDisputed
                  ? parseFloat(item.unitsDisputed).toFixed(3)
                  : parseFloat(0).toFixed(3);
                return item;
              }) || []
            }
            exportFile
            animateRows
            // isScrollOn
            sideBar={false}
            fileName={accountReceivableNDCDatailLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            //onFilterData={false}
            frameworkComponents={frameworkComponents}
            customPDFExport={customPDFExport}
            pinnedBottomRowData={
              NDCDetailTBData?.length > 0 ? pinned : undefined
            }
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
          />
        </div>
      </div>
      <CommonModal
        open={showEstPriDue}
        viewAction
        viewHeader
        modalTitle={estimatePrincipalDue}
        className="panel-header dialog-420"
        customClassJustifycenter
        okTitle="Calculate"
        closeTitle="Cancel"
        data-testid="commonModalcep"
        onOk={() => {
          calculateEstPriDue();
        }}
        onClose={() => {
          setEstPriDue(false);
          setCalculatePriDue(null);
          setNumOfUnitsValue('');
        }}
        childrenComponent={
          <div className="frr-ar-custom-font">
            <div className="dif">
              <label>Current URA:</label>
              <p style={{ marginLeft: '14px', color: 'grey' }}>
                {drugQtrDetail?.unitRebateAmt}
              </p>
            </div>
            <div className="dif">
              <label>Current Units:</label>
              <p style={{ marginLeft: '10px', color: 'grey' }}>
                {drugQtrDetail?.numOfUnits}
              </p>
            </div>
            <div className="dif">
              <label>Paid Amount:</label>
              <p style={{ marginLeft: '11px', color: 'grey' }}>
                {` $ ${drugQtrDetail?.paidAmt}`}
              </p>
            </div>
            <div className="dif">
              <label>Principal Due:</label>
              {calculatePriDue === null ? (
                <p style={{ marginLeft: '9px', color: 'grey' }}>
                  {` $ ${
                    drugQtrDetail?.principalDue ||
                    drugQtrDetail?.principalDue == 0
                      ? parseFloat(drugQtrDetail?.principalDue).toFixed(2)
                      : drugQtrDetail?.principalDue
                  }`}
                </p>
              ) : null}
              {calculatePriDue != null ? (
                <p style={{ marginLeft: '9px', color: 'grey' }}>
                  {` $ ${parseFloat(calculatePriDue).toFixed(2)}`}
                </p>
              ) : null}
            </div>
            <div>
              <div className="mui-custom-form ml-0">
                <TextField
                  id="numUnits"
                  label={numUnitsLabel}
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    const numReg = /^[0-9]*\.?[0-9]*$/;
                    if (e.target.value === '' || numReg.test(e.target.value)) {
                      setNumOfUnitsValue(e.target.value);
                    }
                  }}
                  inputProps={{ maxLength: 20 }}
                  value={numOfUnitsValue}
                />
              </div>
            </div>
          </div>
        }
      />
      <CommonModal
        open={isDialogOpen}
        className="dialog-420"
        viewAction
        viewHeader
        data-testid="commonModal1"
        childrenComponent={dialogText}
        modalTitle="Accounts Receivable NDC Detail"
        okTitle="Ok"
        onOk={() => {
          setIsDialogOpen(false);
        }}
        onClose={() => {
          setIsDialogOpen(false);
        }}
      />
      <CommonModal
        open={confimPopup}
        className="dialog-420"
        data-testid="commonModal2"
        viewAction
        viewHeader
        onOk={() => {
          setConfimPopup(false);
          undoInvoiceBalancedHandler(undoData);
        }}
        okTitle="Ok"
        onClose={() => setConfimPopup(false)}
        childrenComponent={confirmPopupData?.popupText}
        closeTitle="Cancel"
      />
      <CommonModal
        modalTitle="Modify Units From A/R"
        open={modifyUnitsPopup}
        className="panel-header dialog-420"
        viewAction
        viewHeader
        data-testid="commonModal3"
        calculateTitle="Calculate"
        onCalculate={() => {
          calculateEstPriDue();
        }}
        okTitle="Ok"
        onOk={() => {
          handleOkModifyUnitsFromAR();
        }}
        closeTitle="Cancel"
        onClose={() => {
          closeModifyUnitsPopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.modifyunitFailed);
        }}
        childrenComponent={modifyUnitsPopupComponent()}
      />

      <CommonModal
        modalTitle="Override Interest"
        open={overridePopupData?.showPopup}
        className="panel-header dialog-420"
        viewAction
        viewHeader
        data-testid="commonModal4"
        okTitle="Ok"
        onOk={() => {
          handleOkOverrideInterest();
        }}
        closeTitle="Cancel"
        onClose={() => {
          handleCloseOverridePopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.overrideInterestFailed);
        }}
        childrenComponent={overrideInterestPopupComponent()}
      />

      <CommonModal
        modalTitle="Set Units From Claims"
        open={setUnitsPopupData?.showPopup}
        className="panel-header dialog-420"
        viewAction
        viewHeader
        calculateTitle="Calculate"
        isDisabledCalculate
        okTitle="Ok"
        data-testid="commonModal5"
        onOk={() => {
          handleOkSetUnitsToClaims();
        }}
        closeTitle="Cancel"
        onClose={() => {
          handleClosesetUnitsPopup();
          setIsDialogOpen(true);
          setDialogText(AR_CONST.modifyunitFailed);
        }}
        childrenComponent={setUnitsPopupComponent()}
      />

      <CommonModal
        modalTitle="Set Units From Claims"
        open={noClaimPopup?.show}
        className="panel-header dialog-420"
        viewAction
        data-testid="commonModal6"
        viewHeader
        okTitle="Ok"
        onOk={() => {
          setNoClaimPopup({ show: false, msg: '' });
          setSetUnitsPopupData((prev) => {
            return { ...prev, showPopup: true };
          });
        }}
        closeTitle="Cancel"
        onClose={() => {
          setNoClaimPopup({ show: false, msg: '' });
        }}
        childrenComponent={noClaimPopup?.msg}
      />

      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={() => {
            commentsCallFn();
            commentsData(false, '');
          }}
          linkTableName="drug_qtr_details"
          corrLinkId={corrLinkId}
          data-testid="commentsCallFn"
        />
      ) : null}
    </div>
  );
};

export default AccRecNDCDetail;
